// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__K3ypL","log":"ModalInventoryLogs_log__2vYj2","date":"ModalInventoryLogs_date__3NXaN","userName":"ModalInventoryLogs_userName__3BZMa"};